import { postWithJson, postWithFormData } from 'library/utils/serviceUtil'
import axios from 'axios'
// 查询操作日志
export const queryOptLog = params => postWithJson('/sysOperationLog/list.json', params)

